<template>
    <div class="catalog-dropdown" ref="wrpRef">
        <div class="catalog-dropdown__container d-flex">
            <div class="catalog-menu__items">
                <div class="menu-title">{{ category.name }}</div>
                <div ref="scrollRef" :style="{ height: psHeight + 'px'}">
                    <div class="catalog-menu__inner row d-block d-xl-flex d-block d-xl-flex" ref="innerRef">
                        <div
                            v-for="child in childrenItems"
                            :key="'child-'+child.id"
                            :class="childrenItems.length > 4 ? 'col-12 col-lg-6 col-xl-4' : 'col-12 col-lg-6' "
                        >
                            <div class="catalog-menu__level1 d-flex align-items-center justify-content-between">
                                <inertia-link rel="canonical"
                                              :preserve-state="true"
                                              :only="['category', 'parents', 'products', 'filters', 'seo']"
                                              @click="hideCat()"
                                              :href="child.url">{{ child.name_short || child.name }}
                                </inertia-link>
                                <span class="nav-drop">
                                    <i class="ic icon-arrow-right"></i>
                                </span>
                            </div>
                            <MenuSubcat v-if="childrenWithProducts(child).length"
                                        :cat-id="category.id"
                                        :items="childrenWithProducts(child)"
                                        @toggle="update()"
                                        :key="'subcat-'+child.id"/>
                        </div>

                    </div>
                </div>


                <inertia-link :href="category.url"
                              @click="hideCat()"
                              :preserve-state="true"
                              :only="['categories', 'parent', 'popularBrands', 'popularProducts', 'discounts', 'filters', 'seo']"
                              class="button-3 all d-flex align-items-center justify-content-center">
                    <span class="ic icon-squares-four-1"></span>
                    <span class="value">Всі категорії</span>
                </inertia-link>
            </div>
            <MenuBanner v-if="catalogBanner" :banner="catalogBanner" :key="'banner-'+category.id"/>
        </div>
    </div>
</template>

<script setup>
import MenuBanner from "@/frontend/Components/Menu/MenuBanner.vue";
import MenuSubcat from "@/frontend/Components/Menu/MenuSubcat.vue";
import useMenuCatDropdown from "@/frontend/Composables/useMenuCatDropdown";
import { hideCat } from "@/frontend/Composables/useHideCat";

const props = defineProps({
    category: Object
})

const {
    scrollRef,
    wrpRef,
    innerRef,
    psHeight,
    innerHeight,
    banners,
    catalogBanner,
    childrenItems,
    more,
    update,
    childrenWithProducts,
} = useMenuCatDropdown(props)

</script>

<style scoped>

</style>
